import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this._storage = await this.storage.create();
  }

  setValue = async (key, value) => {
    const setValueInStorage = async () => {
      return await this._storage?.set(key, value);
    };
    if (this._storage) {
      return setValueInStorage();
    }

    await this.init();
    return setValueInStorage();
  };

  getValue = async (key) => {
    const getValueFromStorage = async () => {
      return await this._storage?.get(key);
    };
    if (this._storage) {
      return getValueFromStorage();
    }

    await this.init();
    return getValueFromStorage();
  };

  removeKey = async (key) => {
    const removeFromStorage = async () => {
      return await this._storage?.remove(key);
    };
    if (this._storage) {
      return removeFromStorage();
    }

    await this.init();
    return removeFromStorage();
  };
}
